import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import slugify from 'react-slugify';
import { IUser } from '../../../../app/resource/user/user.types';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { buildStyleForSelectInput } from '../../../../utils/form/style.util';
import PeriodAndCustomDateRangeFilters from '../../common/filters/PeriodAndCustomDateRangeFilters';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { ITopbarProps } from './types';
import { useDispatch } from 'react-redux';
import { fetchMeetingReports } from '../../../../app/page/page-storage/reports/reports.actions';
import { IMeetingReportsSearchParams } from '../../../../app/page/page-storage/reports/reports.types';

const Topbar: FunctionComponent<ITopbarProps> = ({ meetingId, memberId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const users = useSelect(userSelectors.selectResourceList);
  let finalUsers = users;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId ?? '');

  if (meetingId) {
    let memberIds = [] as IUser['id'][];
    if (meeting) {
      memberIds = Array.from(new Set([...meeting.administratorIds, ...meeting.shareWithIds]));
    }
    finalUsers = users.filter((user) => memberIds.includes(user.id));
  }

  const userOptions = useMemo(
    () =>
      finalUsers
        .filter((user): user is IUser => user !== null)
        .map((user) => ({
          value: user.id,
          label: `${user.firstName} ${user.lastName}`,
        })),
    [finalUsers],
  );

  const handleChange = (value: any) => {
    if (meeting) {
      history.push(
        `/reports/meetings/${meetingId}/${slugify(meeting?.title, {
          delimiter: '-',
        })}/users/${value}`,
      );
    } else {
      history.push(`/reports/users/${value}`);
    }
  };

  const fetchMeetingReportsCallback = useCallback(
    (params?: IMeetingReportsSearchParams) => {
      if (meetingId) {
        dispatch(fetchMeetingReports(meetingId, { ...params, memberId }));
      }
    },
    [meetingId, memberId, dispatch],
  );

  return (
    <div className="topbar panel flex my-1 p-2 justify-between" style={{ height: 80 }}>
      <div className="flex">
        <button
          id="backbutton"
          className="btn btn-md btn-border white-bg"
          style={{ width: 80, height: '100%', boxShadow: 'none' }}
          onClick={() => history.goBack()}
        >
          <IoMdArrowRoundBack />
          <span className="ml-1">Back</span>
        </button>
        <Select<{ label: string; value: string }, boolean>
          id="administrators"
          name="administrators"
          options={userOptions}
          value={userOptions.find((option) => option.value === memberId)}
          placeholder="Select member"
          isMulti={false}
          onChange={(e: any) => handleChange(e.value)}
          className="custom-select-new"
          styles={{
            ...buildStyleForSelectInput(1),
            control: (base, state) => ({
              ...buildStyleForSelectInput(1).control?.(base, state),
              height: '100%',
              minHeight: 'unset',
              width: 320,
            }),
          }}
        />
      </div>
      <PeriodAndCustomDateRangeFilters callback={fetchMeetingReportsCallback} pageInProgressKey="getMeetingReports" />
    </div>
  );
};
export default Topbar;
